/**
 * CrownIcon - Crown icon component for membership indicators
 * Part of the Butter UI icon system
 */

import { getIconProps, type IconProps } from '#types';

export function CrownIcon({ ariaHidden = true, className = 'h-6 w-6', ...props }: IconProps) {
  return (
    <svg {...getIconProps({ ariaHidden, className, ...props })} viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M12 2l2.5 5.5 6.5 1-4.7 4.6 1.1 6.4-5.9-3.1-5.9 3.1 1.1-6.4L2 8.5l6.5-1L12 2z"
      />
    </svg>
  );
}
